import { Component, OnInit, Input } from '@angular/core';
import { MarsGroup } from '../../../models/MarsGroup';

@Component({
  selector: 'lms-mars-group-tutorization',
  templateUrl: './mars-group-tutorization.component.html',
  styleUrls: ['./mars-group-tutorization.component.scss']
})
export class MarsGroupTutorizationComponent implements OnInit {
  @Input() group: MarsGroup;
  public groupQuestionsListId = 'MARS_GROUP_QUESTIONS_LIST';
  public groupMessagesListId = 'MARS_GROUP_MESSAGES_LIST';
  public groupDebatesListId = 'MARS_GROUP_DEBATES_LIST';
  public tab: string = 'questions';

  constructor() {}

  ngOnInit(): void {}

  changeView(tab) {
    this.tab = tab;
  }
}
